export const GET_PLAN_LIST = "GET_PLAN_LIST";
export const PLAN_PROCESSING = "PLAN_PROCESSING";
export const STOP_PLAN_PROCESSING = "STOP_PLAN_PROCESSING";
